<template lang="pug">
    Aside#polo(:ativo="ativo", @close="ativo = false", v-if="ativo")
        // Fael Interativa
        .info(v-if="polo.isFaelInterativa()")
            h3
                | Unidade {{ polo.nome }}
                br
                | {{ polo.unidade }}

            h4 Endereço
            p.infos
                span {{ polo.rua }}
                span(v-if="polo.complemento") - {{ polo.complemento }}
                span(v-if="polo.bairro") - {{ polo.bairro }}
                br
                span CEP: {{ polo.cep }} - {{ polo.cidade }} - {{ polo.uf }}

            h4 Contato
            p.infos
                a(:href="polo.telefone | telefoneLigavel") {{ polo.telefone | telefoneVisivel }}
                a(:href="polo.telefoneAlternativo | telefoneLigavel", v-if="polo.telefoneAlternativo") | {{ polo.telefoneAlternativo | telefoneVisivel }}
                br
                a(:href="`mailto: ${polo.email}`") {{ polo.email }}

            .warning
                .laranja
                    p Atenção sr(a) candidato(a): As atividades presenciais obrigatórias deverão ser realizadas no polo credenciado UniFAEL em:

            h4 Endereço
            p.infos
                span {{ polo.interativa.rua }}
                span(v-if="polo.interativa.bairro") - {{ polo.interativa.bairro }}
                br
                span CEP: {{ polo.interativa.cep }} - {{ polo.interativa.cidade }} - {{ polo.interativa.uf }}

            h4 Contato
            p.infos
                a(:href="polo.interativa.telefone | telefoneLigavel") {{ polo.interativa.telefone | telefoneVisivel }}
                a(:href="polo.interativa.telefoneAlternativo | telefoneLigavel", v-if="polo.interativa.telefoneAlternativo") | {{ polo.interativa.telefoneAlternativo | telefoneVisivel }}
                br
                a(:href="`mailto: ${polo.interativa.email}`") {{ polo.interativa.email }}

            //- a(:href="$leads.sales_force_url", target="_blank").inscreva-se Inscreva-se agora

            .warning(v-if="tipo == 'grad'")
                .img
                    img(:src="require('@images/icones/warning.png')")
                .laranja
                    p Conforme calendário acadêmico divulgado no Ambiente Virtual de Aprendizagem.

        // Unidade Virtual
        .info(v-else-if="polo.isUnidadeVirtual()")
            h3 {{ polo.unidade }}

            h4 Endereço
            p.infos
                span {{ polo.interativa.rua }}
                span(v-if="polo.interativa.bairro") - {{ polo.interativa.bairro }}
                br
                span CEP: {{ polo.interativa.cep }} - {{ polo.interativa.cidade }} - {{ polo.interativa.uf }}

            h4 Contato
            p.infos
                a(:href="polo.interativa.telefone | telefoneLigavel") {{ polo.interativa.telefone | telefoneVisivel }}
                a(:href="polo.interativa.telefoneAlternativo | telefoneLigavel", v-if="polo.interativa.telefoneAlternativo") | {{ polo.interativa.telefoneAlternativo | telefoneVisivel }}
                br
                a(:href="`mailto: ${polo.interativa.email}`") {{ polo.interativa.email }}

            //- a(:href="$leads.sales_force_url", target="_blank").inscreva-se Inscreva-se agora

            .warning(v-if="tipo == 'grad'")
                .img
                    img(:src="require('@images/icones/warning.png')")
                .laranja
                    p(v-html="MENSAGEM_GRAD")
                    p Conforme calendário acadêmico divulgado no Ambiente Virtual de Aprendizagem.

        // Polos
        .info(v-else)
            h3 {{ polo.unidade }}

            h4 Endereço
            p.infos
                span {{ polo.rua }}
                span(v-if="polo.complemento") - {{ polo.complemento }}
                span(v-if="polo.bairro") - {{ polo.bairro }}
                br
                span CEP: {{ polo.cep }} - {{ polo.cidade }} - {{ polo.uf }}

            h4 Contato
            p.infos
                a(:href="polo.telefone | telefoneLigavel") {{ polo.telefone | telefoneVisivel }}
                a(:href="polo.telefoneAlternativo | telefoneLigavel", v-if="polo.telefoneAlternativo") | {{ polo.telefoneAlternativo | telefoneVisivel }}
                br
                a(:href="`mailto: ${polo.email}`") {{ polo.email }}

            //- a(:href="$leads.sales_force_url", target="_blank").inscreva-se Inscreva-se agora

            .warning(v-if="tipo == 'grad'")
                .img
                    img(:src="require('@images/icones/warning.png')")
                .laranja
                    p(v-html="MENSAGEM_GRAD")
                    p Conforme calendário acadêmico divulgado no Ambiente Virtual de Aprendizagem.
</template>

<script>
import Aside from '@components/Aside/Aside.vue'

const MENSAGEM_GRAD = "Atenção Sr(a) Candidato(a): Polo credenciado MEC para a realização das atividades presenciais obrigatórias para cursos de Graduação."

export default {
    name: "component-polo",
    components: {
        Aside
    },
    props: {
        tipo: {
			type: [String, null],
			default: null,
		},
    },
    data() {
        return {
            polo: {},
            ativo: false,
			MENSAGEM_GRAD,
        }
    },
    created() {
        this.$eventbus.$on('show-polo', polo => {
            this.polo = polo
            this.ativo = true
        })
    },
    watch: {
        ativo: function() {
            if (this.ativo)
                document.querySelector('html').style.overflowY = 'hidden'
            else
                document.querySelector('html').style.removeProperty('overflow-y')
        }
    },
    filters: {
		telefoneVisivel(telefone) {
			if (!telefone)
				return ''
			let p1Total = 4
			let tel = telefone.replace(/\D/gi, '')
			if (tel.length > 10)
				p1Total = 5
			tel = new RegExp(`(?<ddd>\\d{2})(?<p1>\\d{${p1Total}})(?<p2>\\d{4})`).exec(tel)
			return `${tel.groups.ddd} ${tel.groups.p1} ${tel.groups.p2}`
		},
		telefoneLigavel(telefone) {
			if (!telefone)
				return ''
			let tel = telefone.replace(/\D/gi, '')
			return `tel:0${tel}`
		}
	},
}
</script>

<style lang="stylus" scoped src="./Polo.styl"></style>
